import React, {Component, Fragment} from "react";
import {ApiGet} from "../../../shared/services/api-service";
import {normalizeOitReport} from "../../services/analytics";
import {connect} from "react-redux";
import departmentSettingsSelectors from "../../store/department-settings/selectors";
import AnalyticsReport from "../analytics/AnalyticsReport";
import Checkbox from "../../../shared/forms/Checkbox";
import Modal from "../../../shared/ui/Modal";
import reportsActionCreators from "../../store/reports/action-creators";
import './DashboardAnalyticsReport.scss'

class DashboardAnalyticsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      selectedReport: props.type || 'rating',
      reportAnalytics: [],
      selectedQuestionIds: [],
      selectedPhasesMap: {},
      selectedFormTypes: props.departmentSettings.oitAnalyticsFormTypes || ['dor', 'dor2', 'dor3', 'dor3', 'rdor','wor', 'dorr'],
      compact: this.props.compact === undefined? true: this.props.compact,
      mapWeeksToPhaseStart: false
    }
  }

  componentDidMount() {
    this.props.oitGuids && this.props.oitGuids.forEach((oitGuid) => {
      this.setSelectedOit(oitGuid)
    })

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if(this.props.oitGuids && prevProps.oitGuids && prevProps.oitGuids.length !== this.props.oitGuids.length) {
      this.setState({
        reportAnalytics: this.state.reportAnalytics.filter(({oitGuid}) =>
          this.props.oitGuids && this.props.oitGuids.find(og => og === oitGuid)
        )
      })

      this.props.oitGuids &&  this.props.oitGuids.forEach((oitGuid) => {
        this.setSelectedOit(oitGuid)
      })
    }
  }

  get selectedOits() {
    return this.state.reportAnalytics.map(({oitGuid}) => this.getOit(oitGuid))
  }

  get oitsInProgress() {
    return this.props.oits
  }

  get critiqueFormTypes() {
    return this.props.departmentSettings.critiqueFormTypes ? this.props.departmentSettings.critiqueFormTypes : ['ftc'];
  }

  get currentForms() {
    if(!this.props.forms) {
      return []
    }

    return this.props.forms
      .filter(f => f.status === 'current')
      .filter(f => {
        if (this.critiqueFormTypes.includes(f.type)) {
          return this.props.canViewCritiqueForms;
        }
        return true
      })
  }

  getOit(oitGuid) {
    return this.oitsInProgress.find(oit => oit.guid === oitGuid)
  }

  setSelectedOit(oitGuid) {

    if (this.state.reportAnalytics.find((ra) => ra.oitGuid === oitGuid)) {
      return
    }

    let oit = this.getOit(oitGuid);

    if(!this.state.reportAnalytics.length) {
      this.setState({
        selectedPhasesMap: oit.trainingPhases
          .filter(tp => tp.type !== 'orientation')
          .reduce((acc, tp) => ({
            ...acc,
            [tp.sequence]: true
          }), {})
      })
    }

    this.setState({
      selectedOit: oitGuid,
      isLoading: true
    });

    ApiGet(`/api/v1/oits/${oitGuid}/training-phase-analytics/${this.state.selectedFormTypes.join(',')}`)
      .then((res) => {
        const reportAnalytics = normalizeOitReport(res, this.state.mapWeeksToPhaseStart);

        this.setState({
          isLoading: false,
          reportAnalytics: [...this.state.reportAnalytics, {
            raw: res,
            reportAnalytics,
            oitGuid,
            user: oit
          }],
          selectedQuestions: this.addQuestionsToFilter(reportAnalytics.questions),
          selectedQuestionIds: {
            ...this.state.selectedQuestionIds,
            ...reportAnalytics.questionsMapById
          },
        });
      })
  }

  reloadAnalytics() {
    let reportAnalytics = this.state.reportAnalytics;
    this.setState({
      reportAnalytics: [],
      isLoading: true
    }, () =>  {
      Promise.all(reportAnalytics.map(ra => ApiGet(`/api/v1/oits/${ra.oitGuid}/training-phase-analytics/${this.state.selectedFormTypes.join(',')}`)
        .then((res) => {
          const reportAnalytics = normalizeOitReport(res, this.state.mapWeeksToPhaseStart);

          this.setState({
            isLoading: false,
            reportAnalytics: [...this.state.reportAnalytics, {
              raw: res,
              reportAnalytics,
              oitGuid: ra.oitGuid,
              user: this.getOit(ra.oitGuid)
            }],
            selectedQuestions: this.addQuestionsToFilter(reportAnalytics.questions),
            selectedQuestionIds: {
              ...this.state.selectedQuestionIds,
              ...reportAnalytics.questionsMapById
            },
          });
        })))
    })
  }

  addQuestionsToFilter(questions) {
    return Object.assign(questions.reduce((acc, question) => ({
      ...acc,
      [question]: true
    }), {}), this.state.selectedQuestions)
  }

  filteredQuestions() {
    return Object.keys(this.state.selectedQuestions).filter(question => this.state.selectedQuestions[question]);
  }

  updateSelectedPhases(sequence, checked) {
    this.setState({
      selectedPhasesMap: {
        ...this.state.selectedPhasesMap,
        [sequence]: checked
      }
    })

  }

  handleFilterClick() {
    this.setState({
      showQuestionsModal: true
    });
  }

  handleFormTypeClick() {
    this.setState({
      showFormTypeModal: true
    });
  }

  closeQuestionsModal(e) {
    this.setState({
      showQuestionsModal: false
    });
  }

  closeFormTypeModal(e) {
    this.setState({
      showFormTypeModal: false
    });
  }

  isFormTypeChecked(form) {
    return this.state.selectedFormTypes.includes(form.type)
  }

  selectAllQuestions(value) {
    let questions = {};
    for (const property in this.state.selectedQuestions) {
      questions[property] = value;
    }

    this.setState({
      selectedQuestions: questions,
      selectAll: value,
      deselectAll: !value
    });
  }

  deselectAllQuestions(value) {
    let questions = {};
    for (const property in this.state.selectedQuestions) {
      questions[property] = !value;
    }

    this.setState({
      selectedQuestions: questions,
      selectAll: !value,
      deselectAll: value
    });
  }

  onReportClick(data) {
    this.props.setIsViewingReport(data);
  }

  onQuestionChange(value, fieldKey) {
    let selectedQuestions = this.state.selectedQuestions;
    selectedQuestions[fieldKey] = value

    this.setState({
      selectedQuestions: selectedQuestions,
      selectAll: false,
      deselectAll: false
    });

  }

  applyChanges() {
    this.setState({
      showFormTypeModal: false
    })
    this.reloadAnalytics()
  }



  onFormTypeSelectChange(checked, form) {
    let selectedFormTypes = [...this.state.selectedFormTypes];
    if(checked) {
      selectedFormTypes = [...selectedFormTypes.filter(f => f !== form.type), form.type];
    } else {
      selectedFormTypes = selectedFormTypes.filter(f => f !== form.type);
    }

    this.setState({
      selectedFormTypes
    })
  }


  getAllQuestions() {
    const that = this;
    let questions = {};


    this.state.reportAnalytics.reduce((acc, obj) => {
      obj.reportAnalytics.questions.reduce((acc, question) => {
        const questionStatus = that.state.selectedQuestions[question];
        questions[question] = questionStatus;

        return acc;
      }, {});

      return acc;
    }, {});


    return Object.keys(questions);
  }

  recalculateReportAnalytics() {
    this.setState({
      reportAnalytics: this.state.reportAnalytics.map((ra) => ({
        ...ra,
        reportAnalytics: normalizeOitReport(ra.raw, this.state.mapWeeksToPhaseStart)
      }))
    })
  }

  onMapWeeksToPhaseStartChange(checked) {
    this.setState({
      mapWeeksToPhaseStart: checked
    }, () => {
      this.recalculateReportAnalytics()
    });

  }


  render() {
    return (
      <div className="dashboard-statistics-report">
        <div className="dashboard-statistics-report-buttons" style={{display: 'flex', marginTop: '20px'}}>
          <div className="mr-2">
            <button className="button secondary" onClick={() => this.handleFormTypeClick()}>
              <i className="fa fa-paperclip"/>
              Form types
            </button>
          </div>
          <div className="ml-2">
            <button className="button secondary" onClick={() => this.handleFilterClick()}>
              <i className="fa fa-filter"/>
              Filter questions
            </button>
          </div>
        </div>

        <br/>
        <Checkbox
          label={'Map weeks to phase starts'}
          onChange={(event) => this.onMapWeeksToPhaseStartChange(event.target.checked)}
          checked={this.state.mapWeeksToPhaseStart}/>

        {this.state.reportAnalytics.length && !this.props.userContext.hasScope('oit') ? (
          <div className="selected-users">
            <br/>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
              {this.state.reportAnalytics[0].user.trainingPhases
                .filter(tp => tp.type !== 'orientation')
                .map(tp => (
                  <div key={tp.trainingPhaseGuid} style={{marginRight: '10px'}}>
                    <Checkbox
                      label={tp.header}
                      checked={this.state.selectedPhasesMap[tp.sequence]}
                      onChange={e => this.updateSelectedPhases(tp.sequence, e.target.checked)}
                    />
                  </div>
                ))}
            </div>
          </div>
        ) : null}
        {this.state.reportAnalytics.length > 0 && (
          <AnalyticsReport
            isSelf={this.props.userContext.hasScope('oit')}
            reportAnalytics={this.state.reportAnalytics}
            filteredQuestions={this.filteredQuestions()}
            departmentSettings={this.props.departmentSettings}
            reportType={this.state.selectedReport}
            selectedPhasesMap={this.state.selectedPhasesMap}
            reportClick={this.onReportClick.bind(this)}
            compact={this.state.compact}
          />
        )}

        <Modal
          fullscreen={true}
          title="Choose Observations"
          isOpen={this.state.showQuestionsModal}
          onClose={(e) => this.closeQuestionsModal(e)}
          size="sm"
        >
          <div className="questions-container">
            <div className="select-all">
              <div className="btn-container">
                <button className="button secondary" onClick={() => this.selectAllQuestions(true)}>
                  Select All
                </button>
              </div>

              <div className="btn-container right">
                <button className="button secondary" onClick={() => this.deselectAllQuestions(true)}>
                  Deselect All
                </button>
              </div>
            </div>

            {this.state.reportAnalytics.length > 0 && this.getAllQuestions().map(question => (
              <Checkbox
                key={question}
                checked={this.state.selectedQuestions[question]}
                label={question}
                onChange={(e) => {
                  this.onQuestionChange(e.target.checked, question)
                }}
              />
            ))}
          </div>
        </Modal>
        <Modal
          fullscreen={true}
          title="Choose form types to display"
          isOpen={this.state.showFormTypeModal}
          onClose={(e) => this.closeFormTypeModal(e)}
          size="sm"
        >
          <div className="p-3">
            {this.currentForms.map(form => (
              <Checkbox
                key={form.type}
                checked={this.isFormTypeChecked(form)}
                label={form.name}
                onChange={(e) => {
                  this.onFormTypeSelectChange(e.target.checked, form)
                }}
              />
            ))}
            <div>
              <button className="button primary mt-3" onClick={() => this.applyChanges()}>
                Apply changes
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    oits: state.oits.list,
    viewingReport: state.reports.viewingReport,
    departmentSettings: state.departmentSettings.settings,
    canViewCritiqueForms: departmentSettingsSelectors.canViewCritiqueForms(state),
    oitShortLabel: departmentSettingsSelectors.oitShortLabel(state),
    forms: state.forms.list,
    userContext: state.common.userContext
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setIsViewingReport: (report) => {
      return dispatch(reportsActionCreators.setIsViewingReport(report));
    },
  }
}
export default connect(mapStateToProps, mapDispatchToProps)(DashboardAnalyticsReport)
